import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'home',
        component: () => import('@/views/exhibitors/lists.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/Login.vue'),
    },
    {
        path: '/login/email',
        name: 'emaillogin',
        component: () => import('@/views/login/EmailLogin.vue'),
    },
    {
        path: '/login/weixin',
        name: 'weixinlogin',
        component: () => import('@/views/login/WeiXin.vue'),
    },
    {
        path: '/exhibitors/lists',
        name: 'exhibitorsLists',
        component: () => import('@/views/exhibitors/lists.vue'),
    },
    {
        path: '/exhibitors/details',
        name: 'exhibitorsDetails',
        component: () => import('@/views/exhibitors/details.vue'),
    },


    {
        path: '/products/lists',
        name: 'productsLists',
        component: () => import('@/views/products/products_lists.vue'),
    },
    {
        path: '/products/details',
        name: 'productsDetails',
        component: () => import('@/views/products/products_details.vue'),
    },
    {
        path: '/products/gcdetail',
        name: 'productsDetails',
        component: () => import('@/views/products/gc_details.vue'),
    },
    {
        path: '/products/fwsdetail',
        name: 'productsDetails',
        component: () => import('@/views/products/fws_details.vue'),
    },
    {
        path: '/brand/fwsdetail',
        name: 'productsDetails',
        component: () => import('@/views/products/fws_details.vue'),
    },
    {
        path: '/products/hrdetail',
        name: 'productsDetails',
        component: () => import('@/views/products/hr_detail.vue'),
    },
    {
        path: '/brand/detail',
        name: 'brandDetail',
        component: () => import('@/views/brand/brand_detail.vue'),
    },
    {
        path: '/brand/gcdetail',
        name: 'brandDetail',
        component: () => import('@/views/brand/gc_brand_detail.vue'),
    },
    {
        path: '/brand/hr',
        name: 'brandDetail',
        component: () => import('@/views/brand/hongren_detail.vue'),
    },
    {
        path: '/release-req',
        name: 'releaseReq',
        component: () => import('@/views/release_req/release-req.vue'),
    },
    {
        path: '/search/one',
        name: 'searchone',
        component: () => import('@/views/search/search_result_one.vue'),
    },
    {
        path: '/search/two',
        name: 'searchtwo',
        component: () => import('@/views/search/search_result_two.vue'),
    },
    {
        path: '/search/three',
        name: 'searchthree',
        component: () => import('@/views/search/search_result_three.vue'),
    },
    {
        path: '/release-req-two',
        name: 'releaseReqTwo',
        component: () => import('@/views/release_req/release-req-two.vue'),
    },


    {
        path: '/my/like',
        name: 'myLike',
        component: () => import('@/views/my/Like.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
